import React from 'react';
import PrintEditor from '../components/print/PrintEditor';
import { Paper } from '@material-ui/core';

const PrintView = () => {

  return (
    <>
      <Paper elevation={2}>
        <PrintEditor />
      </Paper>
    </>
  );
};


export default PrintView;
